import * as React from "react";
import {UserResource} from "client/resources";
import styles = require("./style.less");

const avatarPlaceHolder = require("./img/avatar-placeholder.svg");
const octopusServiceImage = require("./img/octopus-service-440.svg");
const userDefaultImage = require("./img/user-placeholder.svg");

interface AvatarProps {
    user?: UserResource;
    size?: number;
}

export const Avatar: React.StatelessComponent<AvatarProps> = props => {
    const size = props.size || 25;
    let imageSource = avatarPlaceHolder;
    if (!props.user) {
        imageSource = octopusServiceImage;
    } else if (props.user.IsService) {
        imageSource = octopusServiceImage;
    } else if (props.user.Links && props.user.Links.Avatar) {
        imageSource = `${props.user.Links.Avatar}&s=${size}`;
    }
    return (
        // Note: Do NOT use Material-UI's Avatar component to render avatars, as we need a fallback background image and
        // if you try to do this with the <img> tag, it'll then show broken external images on closed networks (I.e. networks
        // that can't access gravatar).
        <div className={styles.avatarContainer}
            style={{
                backgroundImage: `url("${userDefaultImage}")`,
                width: size + "px",
                height: size + "px"
            }}>
            <div className={styles.avatarContainer}
                style={{
                    backgroundImage: `url("${imageSource}")`,
                    width: "100%",
                    height: "100%"
                }} />
        </div>
    );
};

export default Avatar;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Avatar/Avatar.tsx